import React from 'react';

const Dashboar_Footer = () => {
  return (
    <>
      <footer class="footer">
        <div class="container-fluid">
          <div class="row">
            <div class="col-12 text-center">
              <script>document.write(new Date().getFullYear())</script>  {' '}
              <iconify-icon
                icon="iconamoon:heart-duotone"
                class="fs-18 align-middle text-danger"
              ></iconify-icon>{' '}
              <p
                class="fw-bold footer-text"
              >
                &copy;
                Glorious Evidence.
              </p>
            </div>
          </div>
        </div>
      </footer>
    </>
  );
};

export default Dashboar_Footer;
